import { render } from "./Logout.vue?vue&type=template&id=55359aea&scoped=true&ts=true&lang=pug"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"

import "./Logout.vue?vue&type=style&index=0&id=55359aea&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./Logout.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/components/logout.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FLogout.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55359aea"]])

export default __exports__